import React from 'react';
import './card.scss'

export const Card = ({ text, image, title }) => {
  return (
    <>
      <div className="card">
        <div className="card__content">
          <h3>{title}</h3>
          <img src={image} alt="settings" />
        </div>
        <p dangerouslySetInnerHTML={{__html: text}}></p>
      </div>
    </>
  );
};
